import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=26634b0f&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=ts"
export * from "./FooterLinks.vue?vue&type=script&lang=ts"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=26634b0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26634b0f",
  null
  
)

export default component.exports